<template>
<div>
    <div v-if="this.name == 'chat'">
        <div class="chat-wrapper flex">
            <div style="width:280px;">
                <v-conversation-list class="chat-container-left" v-if="true" />
            </div>
            <div style="width:620px">
                <v-current-conversation  :isClose="'false'" />
            </div>
        </div>
    </div>
    <div v-else>

        <el-dialog
            width="800px"
            top="5vh"
            :visible.sync="chatDialogVisible"
            v-if="chatDialogVisible"
            custom-class="chat-dialog-with-employee-tim"
            :before-close="handleClose"
            modal-append-to-body
            append-to-body
        >
            <!-- <div slot="title">
                <div>1001022</div>
            </div> -->
            <div class="chat-wrapper">
                <template v-if="this.showList">
                    <el-row>
                        <el-col
                            :xs="10"
                            :sm="10"
                            :md="8"
                            :lg="8"
                            :xl="7"
                        >
                            <v-conversation-list />
                        </el-col>
                        <el-col
                            :xs="14"
                            :sm="14"
                            :md="16"
                            :lg="16"
                            :xl="17"
                        >
                            <v-current-conversation />
                        </el-col>
                    </el-row>
                </template>
                <template v-else>

                    <el-row>
                        <el-col
                            :xs="10"
                            :sm="10"
                            :md="8"
                            :lg="8"
                            :xl="7"
                        >
                            <v-conversation-list v-if="false" />
                        </el-col>
                        <el-col
                            :xs="24"
                            :sm="24"
                            :md="24"
                            :lg="24"
                            :xl="24"
                        >
                            <v-current-conversation />
                        </el-col>
                    </el-row>
                </template>


                <v-call />
            </div>
        </el-dialog>
    </div>

</div>

</template>

<script>
import { 
    // mapState, 
    mapGetters 
} from 'vuex'
import ConversationList from '@/components/Tim/ConversationList'
import CurrentConversation from '@/components/Tim/CurrentConversation'
import Calling from '@/components/Tim/Call.vue'
import { ACTION } from '@/utils/funcTim.js'

export default {
    name: 'TimChatWithEmployee',
    components: {
        'v-conversation-list': ConversationList,
        'v-current-conversation': CurrentConversation,
        'v-call': Calling
    },
    data() {
        return {}
    },
    props: {
        name: {
            type: String,
        },
    },
    computed: {
        // ...mapState({
        //     chatDialogVisible: state => state.timStore.chatDialogVisible,
        //     userInfo: state => state.timStore.userInfo,
        //     currentConversation: state => state.timStore.currentConversation
        // }),
        ...mapGetters([
            'isTIM',
            'toAccount',
            'chatDialogVisible',
            'userInfo',
            'currentConversation',
            'showList'

        ])
    },
    watch: {
        chatDialogVisible(newVal) {
            if (newVal) {
                // 收到新消息
                console.log(this.currentConversation.conversationID)
            }
        }
    },
    async mounted() {
        console.log('被执行---/Tim/ChatWithEmployee')
        await this.initListener()
    },
    beforeRouteLeave: function(to, from, next) {
        console.log('beforeRouteLeave----执行destroyed')
        this.removeListener()
        next();
    },
    destroyed() {
        console.log('执行destroyed')
        this.removeListener()
    },
    methods: {
        handleClose() {
            this.$store.commit('toogleChatDialog')
        },
        removeListener() {
            // 登录成功后会触发 SDK_READY 事件，该事件触发后，可正常使用 SDK 接口
            this.$TIM.off(this.$TIM_EVENT.SDK_READY, this.onReadyStateUpdate, this)
            // SDK NOT READT
            this.$TIM.off(this.$TIM_EVENT.SDK_NOT_READY, this.onReadyStateUpdate, this)
            // 被踢出
            this.$TIM.off(this.$TIM_EVENT.KICKED_OUT, this.onKickOut)
            // SDK内部出错
            this.$TIM.off(this.$TIM_EVENT.ERROR, this.onError)
            // 收到新消息
            this.$TIM.off(this.$TIM_EVENT.MESSAGE_RECEIVED, this.onReceiveMessage)
            // 会话列表更新
            this.$TIM.off(this.$TIM_EVENT.CONVERSATION_LIST_UPDATED, this.onUpdateConversationList)
            // 网络监测
            this.$TIM.off(this.$TIM_EVENT.NET_STATE_CHANGE, this.onNetStateChange)
            // 已读回执
            this.$TIM.off(this.$TIM_EVENT.MESSAGE_READ_BY_PEER, this.onMessageReadByPeer)
        },
        initListener() {
            // 登录成功后会触发 SDK_READY 事件，该事件触发后，可正常使用 SDK 接口
            this.$TIM.on(this.$TIM_EVENT.SDK_READY, this.onReadyStateUpdate, this)
            // SDK NOT READT
            this.$TIM.on(this.$TIM_EVENT.SDK_NOT_READY, this.onReadyStateUpdate, this)
            // 被踢出
            this.$TIM.on(this.$TIM_EVENT.KICKED_OUT, this.onKickOut)
            // SDK内部出错
            this.$TIM.on(this.$TIM_EVENT.ERROR, this.onError)
            // 收到新消息
            this.$TIM.on(this.$TIM_EVENT.MESSAGE_RECEIVED, this.onReceiveMessage)
            // 会话列表更新
            this.$TIM.on(this.$TIM_EVENT.CONVERSATION_LIST_UPDATED, this.onUpdateConversationList)
            // 网络监测
            this.$TIM.on(this.$TIM_EVENT.NET_STATE_CHANGE, this.onNetStateChange)
            // 已读回执
            this.$TIM.on(this.$TIM_EVENT.MESSAGE_READ_BY_PEER, this.onMessageReadByPeer)
        },
        async onReadyStateUpdate({ name }) {
            const isSDKReady = name === this.$TIM_EVENT.SDK_READY
            this.$store.commit('toggleIsSDKReady', isSDKReady)
            console.log('==============SDK_READY==============', isSDKReady)

            if (isSDKReady) {
                this.$TIM.getMyProfile()
                    .then(({ data }) => {
                        this.$store.commit('updateCurrentUserProfile', data)
                    })
                    .catch((error) => {
                        this.$message.error(error.message)
                    })
                // 获取当前会话列表
                // this.$TIM.getConversationList().then((imResponse) => {
                //     const conversationList = imResponse.data.conversationList
                //     console.log(conversationList)
                //     console.log('-------------------------')
                //     this.$store.commit('updateConversationList', conversationList)
                // })

                // 登录trtc calling
                // this.trtcCalling.login({
                //     userID: this.userInfo.userID,
                //     userSig: this.userInfo.userSig
                // }).then(() => {
                //     console.log('==============实时音视频登录成功==============')
                // }).catch(() => {
                //     console.warn('==============实时音视频登录失败==============')
                // })
            }
        },
        async onReceiveMessage({ data: messageList }) {
            await this.handleVideoMessage(messageList)
            await this.$store.commit('pushCurrentMessageList', messageList)
            console.log('==============================onReceiveMessage===================')
            console.log('收到消息***********', messageList)
            let userID = this.$store.getters.currentUserProfile.userID
            messageList.forEach(element => {
                if (element.from !== userID) {
                    if (!this.chatDialogVisible) {
                        this.$store.commit('setNewMessageStatus', true)
                    }
                }
                if (this.chatDialogVisible) {
                    if (`C2C${element.from}` === this.$store.state.timStore.currentConversation.conversationID) {
                        this.$store.dispatch('setMessageRead')
                    }
                }
            });
            console.log(userID)
            console.log('聊天人-对方', this.$store.state.timStore.currentConversation.conversationID)

        },
        async onUpdateConversationList(event) {
            // 获取会话列表
            await this.$store.commit('updateConversationList', event.data)
        },
        handleVideoMessage(messageList) {
            const videoMessageList = messageList.filter(
                message => message.type === this.$TIM_TYPES.MSG_CUSTOM && this.isJsonStr(message.payload.data)
            )
            if (videoMessageList.length === 0) return
            const videoPayload = JSON.parse(videoMessageList[0].payload.data)
            if (videoPayload.action === ACTION.VIDEO_CALL_ACTION_DIALING) {
                if (this.isBusy) {
                    this.$bus.$emit('busy', videoPayload, videoMessageList[0])
                    return
                }
                this.$store.commit('GENERATE_VIDEO_ROOM', videoPayload.room_id)
                this.selectConversation(videoMessageList[0].conversationID) // 切换当前会话页
                if (videoMessageList[0].from !== this.userID) {
                    this.$bus.$emit('isCalled')
                }
            }
            if (videoPayload.action === ACTION.VIDEO_CALL_ACTION_SPONSOR_CANCEL) {
                this.$bus.$emit('missCall')
            }
            if (videoPayload.action === ACTION.VIDEO_CALL_ACTION_REJECT) {
                this.$bus.$emit('isRefused')
            }
            if (videoPayload.action === ACTION.VIDEO_CALL_ACTION_SPONSOR_TIMEOUT) {
                this.$bus.$emit('missCall')
            }
            if (videoPayload.action === ACTION.VIDEO_CALL_ACTION_ACCEPTED) {
                this.$bus.$emit('isAccept')
            }
            if (videoPayload.action === ACTION.VIDEO_CALL_ACTION_HANGUP) {
                this.$bus.$emit('isHungUp')
            }
            if (videoPayload.action === ACTION.VIDEO_CALL_ACTION_LINE_BUSY) {
                this.$bus.$emit('isRefused')
            }
            if (videoPayload.action === ACTION.VIDEO_CALL_ACTION_ERROR) {
                this.$bus.$emit('isRefused')
            }
        },
        selectConversation(conversationID) {
            if (conversationID !== this.currentConversation.conversationID) {
                this.$store.dispatch('checkoutConversation', conversationID)
            }
        },
        isJsonStr(str) {
            try {
                JSON.parse(str)
                return true
            } catch {
                return false
            }
        },
        onMessageReadByPeer() {},
        async onKickOut(event) {
            // TODO
            console.log(`${this.kickedOutReason(event.data.type)}被踢出，请重新登录。`)
            // await this.$store.commit('showMessage', {
            //     message: `${this.kickedOutReason(event.data.type)}被踢出，请重新登录。`,
            //     type: 'error'
            // })
            await this.$store.commit('toggleIsLogin', false)
            await this.$store.commit('loginReset')
            // await this.$store.dispatch('getOnlineCustomer', true)
        },
        kickedOutReason(type) {
            switch (type) {
                case this.$TIM_TYPES.KICKED_OUT_MULT_ACCOUNT:
                    return this.$t('由于多实例登录')
                case this.$TIM_TYPES.KICKED_OUT_MULT_DEVICE:
                    return this.$t('由于多设备登录')
                case this.$TIM_TYPES.KICKED_OUT_USERSIG_EXPIRED:
                    return this.$t('由于 userSig 过期')
                default:
                    return ''
            }
        },
        onNetStateChange(event) {
            console.log(event)
            // this.$store.commit('showMessage', this.checkoutNetState(event.data.state))
        },
        checkoutNetState(state) {
            switch (state) {
                case this.$TIM_TYPES.NET_STATE_CONNECTED:
                    return { message: this.$t('已接入网络'), type: 'success' }
                case this.$TIM_TYPES.NET_STATE_CONNECTING:
                    return { message: this.$t('当前网络不稳定'), type: 'warning' }
                case this.$TIM_TYPES.NET_STATE_DISCONNECTED:
                    return { message: this.$t('当前网络不可用'), type: 'error' }
                default:
                    return ''
            }
        },
        onError({ data }) {
            if (data.message !== 'Network Error') {
                if (data.code !== 3000) {
                    this.$store.commit('showMessage', {
                        message: data.message,
                        type: 'error'
                    })
                }
            }
        }
    }
}
</script>

<style lang="scss">
.chat-dialog-with-employee-tim {
    width: 100%;
    .el-dialog__header {
        padding: 10px 0;
        background: #ffffff;
    }
    .el-dialog__body {
        padding: 0 20px;
    }

    .chat-wrapper {
        height: 608px;
        padding-bottom: 20px;
        position: relative;
    }
    /* .call-wrapper {
        width: calc(100% + 40px);
        height: calc(608px + 20px);
        position: absolute;
        left: -20px;
        top: -20px;
    } */
}
</style>
